import { createRouter, createWebHistory } from 'vue-router'

import AppHome from '@/views/AppHome.vue'
import AppHomeManage from '@/views/AppHomeManage.vue'
import AppHomeOperate from '@/views/AppHomeOperate.vue'
import AppLogin from '@/views/AppLogin.vue'
import NotFound from '@/views/NotFound.vue'

import Client from './client'
import ExportData from './export_data'
import Item from './item'
import ItemPrice from './item_price'
import Supplier from './supplier'
import User from './user'

import ManageInspection from '@/apps/inspection/manage/router'
import ManageInspectionMonitor from '@/apps/inspection_monitor/manage/router'
import ManageInspectionPlan from '@/apps/inspection_plan/manage/router'
import ManageInventory from '@/apps/inventory/manage/router'
import ManageOrder from '@/apps/order/manage/router'
import ManagePurchase from '@/apps/purchase/manage/router'

import OperateInspection from '@/apps/inspection/operate/router'
import OperateInspectionMonitor from '@/apps/inspection_monitor/operate/router'
import OperateInspectionPlan from '@/apps/inspection_plan/operate/router'
import OperateInventory from '@/apps/inventory/operate/router'
import OperateOrder from '@/apps/order/operate/router'
import OperatePurchase from '@/apps/purchase/operate/router'

// store
import store from '@/store'

const routes = [
  {
    path: '/',
    component: AppHome,
    name: 'AppHome',
    meta: { requiresAuth: true },
  },
  {
    path: '/manage',
    component: AppHomeManage,
    name: 'AppHomeManage',
    meta: { requiresAuth: true },
  },
  {
    path: '/operate',
    component: AppHomeOperate,
    name: 'AppHomeOperate',
    meta: { requiresAuth: true },
  },
  {
    path: '/login',
    component: AppLogin,
    name: 'AppLogin',
  },
  ...User.routes,
  ...Item.routes,
  ...ItemPrice.routes,
  ...Client.routes,
  ...Supplier.routes,
  ...ExportData.routes,
  ...ManageInspection.routes,
  ...ManageInspectionMonitor.routes,
  ...ManageInspectionPlan.routes,
  ...ManageInventory.routes,
  ...ManageOrder.routes,
  ...ManagePurchase.routes,
  ...OperateInventory.routes,
  ...OperateInspection.routes,
  ...OperateInspectionMonitor.routes,
  ...OperateInspectionPlan.routes,
  ...OperateOrder.routes,
  ...OperatePurchase.routes,
  {
    path: '/:pathMatch(.*)*',
    component: NotFound,
    name: 'NotFound',
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes: routes,
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !store.getters['auth/is_logged_in']) {
    if (store.getters['auth/is_token']) {
      store.dispatch('auth/renew').then(() => {
        next()
      })
    } else {
      router.replace({
        name: 'AppLogin',
        query: { redirect: to.fullPath },
      })
    }
  } else {
    next()
  }
})

router.afterEach((to) => {
  // タイトルを設定
  const activeApp = store.getters['auth/activeApp']
  if (activeApp('inspection_monitor')) {
    document.title = 'モニターシステム'
    setFavicon('/inspection_monitor/favicons/favicon.ico')
    setManifest('/inspection_monitor/manifest.json')
  } else if (to.meta && to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = process.env.VUE_APP_TITLE
  }
})

const setFavicon = (href) => {
  const link = document.getElementById('dynamic-favicon')
  if (link) {
    link.href = href
  }
}

const setManifest = (href) => {
  const link = document.getElementById('dynamic-manifest')
  if (link) {
    link.href = href
  }
}

export default router
